import { useState } from 'react';
import Panel from '../Panel';
import Tabs from '../Tabs';
import ClientInfoTab from './tabs/ClientInfoTab';
import CampaignRequestTab from './tabs/CampaignRequestTab';
import CampaignTab from './tabs/CampaignTab';
import MedicalInfoTab from './tabs/MedicalInfoTab';
import TeamTab from './tabs/TeamTab';
import DisbursementsTab from './tabs/DisbursementsTab';
import FilesTab from './tabs/FilesTab';

interface Props {
    patient: any;
    metadata: any;
    campaign: any;
    campaignRequest: any;
    application: any;
    approval?: any;
    onCampaignRequestUpdate?: (updatedCampaignRequest: any) => void;
    onDataUpdate?: () => void;
    csc?: any;
    campaignDispatch?: any;
}

const PrimaryTabs: React.FC<Props> = ({
    patient,
    metadata,
    campaign,
    campaignRequest,
    application,
    approval,
    onCampaignRequestUpdate,
    onDataUpdate,
    csc,
    campaignDispatch,
}) => {
    const [openTab, setOpenTab] = useState<number>(1);

    const isCompassion = campaign?.campaign_type?.code === 'compassion';

    const tabs = [
        !isCompassion && {
            name: 'Client Info',
            render: () => (
                <ClientInfoTab
                    campaign={campaign}
                    patient={patient}
                    metadata={metadata}
                    application={application}
                    onDataUpdate={onDataUpdate}
                />
            ),
        },
        !isCompassion && {
            name: 'Request',
            render: () => (
                <CampaignRequestTab
                    campaignRequest={campaignRequest}
                    patient={patient}
                    metadata={metadata}
                    application={application}
                    approval={approval}
                    onCampaignRequestUpdate={onCampaignRequestUpdate}
                />
            ),
        },
        {
            name: 'Campaign',
            render: () => (
                <CampaignTab
                    csc={csc}
                    campaign={campaign}
                    campaignRequest={campaignRequest}
                    patient={patient}
                    onDataUpdate={onDataUpdate}
                />
            ),
        },
        !isCompassion && {
            name: 'Medical Info',
            render: () => (
                <MedicalInfoTab
                    metadata={metadata}
                    patient={patient}
                    campaign={campaign}
                    campaignRequest={campaignRequest}
                    application={application}
                    onDataUpdate={onDataUpdate}
                    campaignDispatch={campaignDispatch}
                />
            ),
        },
        {
            name: 'Team',
            render: () => (
                <TeamTab
                    campaign={campaign}
                    metadata={metadata}
                    csc={csc}
                    patient={patient}
                    application={application}
                    onDataUpdate={onDataUpdate}
                    campaignDispatch={campaignDispatch}
                />
            ),
        },
        {
            name: 'Disbursements',
            render: () => <DisbursementsTab campaign={campaign} />,
        },
        {
            name: 'Files',
            render: () => (
                <FilesTab
                    campaign={campaign}
                    patient={patient}
                    application={application}
                />
            ),
        },
    ].filter(Boolean) as { name: string; render: () => JSX.Element }[];

    const activeTab = tabs[openTab - 1] ?? tabs[0];

    return (
        <>
            <Panel>
                <Tabs
                    openTab={openTab}
                    setOpenTab={setOpenTab}
                    tabNames={tabs.map(({ name }) => ({ name }))}
                >
                    {activeTab?.render()}
                </Tabs>
            </Panel>
        </>
    );
};

export default PrimaryTabs;
